import { colorUsage } from 'stylesheet';
export var getBorderColorFromStatus = function getBorderColorFromStatus(status) {
  return status ? colorUsage.dropzone[status].borderColor : colorUsage.dropzone.base.borderColor;
};